import _ from 'lodash';
import React, { Component } from 'react';
import { Checkbox, Tree } from 'antd';
import update from 'immutability-helper';
import { gre } from '@achievable-me/tundra-wizard/content';
import {
  countItemsAvailable,
  recursiveInfo,
} from '@achievable-me/tundra-wizard/contentHelpers';
import styles from './styles.scss';

const { quantContentUuids, vocabContentUuids } = gre;

const GreCheckboxes = (props) => {
  const { contentUuids, handleCheckAllQuantChange, handleCheckAllVocabChange } = props;

  const selectedQuantContentUuids = _.intersection(contentUuids, quantContentUuids);
  const selectedVocabContentUuids = _.intersection(contentUuids, vocabContentUuids);

  return (
    <>
      <Checkbox
        indeterminate={
          selectedQuantContentUuids.length &&
          selectedQuantContentUuids.length < quantContentUuids.length
        }
        onChange={handleCheckAllQuantChange}
        checked={selectedQuantContentUuids.length === quantContentUuids.length}
      >
        Select all quantitative
      </Checkbox>
      <Checkbox
        indeterminate={
          selectedVocabContentUuids.length &&
          selectedVocabContentUuids.length < vocabContentUuids.length
        }
        onChange={handleCheckAllVocabChange}
        checked={selectedVocabContentUuids.length === vocabContentUuids.length}
      >
        Select all vocab
      </Checkbox>
    </>
  );
};

const generateTreeData = (contentInstance) => {
  if (!contentInstance) {
    return null;
  }

  const { uuid, name, content } = contentInstance;

  const ourInfo = recursiveInfo(contentInstance);
  const itemInfo = ourInfo.itemsAvailable
    ? `${ourInfo.itemsAvailable} (${ourInfo.itemsReady})`
    : '0';

  return {
    title: `${name} | ${itemInfo}`,
    key: uuid,
    selectable: false,
    disabled: !ourInfo.itemsAvailable,
    disableCheckbox: !ourInfo.itemsAvailable,
    children: content.map((child) => generateTreeData(child)),
  };
};

const ContentTree = (props) => {
  const { contentSkeleton, contentUuids, handleCheckboxesChange } = props;

  const treeData = contentSkeleton.map((contentInstance) =>
    generateTreeData(contentInstance)
  );

  return (
    <div className={styles.contentList}>
      <Tree
        checkable
        selectable={false}
        checkedKeys={contentUuids}
        onCheck={handleCheckboxesChange}
        treeData={treeData}
      />
    </div>
  );
};

class SessionOptions extends Component {
  handleCheckAllChange = (e) => {
    const { quizState, setOptions } = this.props;
    const { allContentUuids, options } = quizState;

    const nextContentUuids = e.target.checked ? allContentUuids : [];
    const nextOptions = update(options, { contentUuids: { $set: nextContentUuids } });
    setOptions(nextOptions);
  };

  handleCheckAllQuantChange = (e) => {
    const { quizState, setOptions } = this.props;
    const { options } = quizState;
    const { contentUuids } = options;

    const nextContentUuids = e.target.checked
      ? _.union(contentUuids, quantContentUuids)
      : _.difference(contentUuids, quantContentUuids);
    const nextOptions = update(options, { contentUuids: { $set: nextContentUuids } });
    setOptions(nextOptions);
  };

  handleCheckAllVocabChange = (e) => {
    const { quizState, setOptions } = this.props;
    const { options } = quizState;
    const { contentUuids } = options;

    const nextContentUuids = e.target.checked
      ? _.union(contentUuids, vocabContentUuids)
      : _.difference(contentUuids, vocabContentUuids);
    const nextOptions = update(options, { contentUuids: { $set: nextContentUuids } });
    setOptions(nextOptions);
  };

  handleCheckboxesChange = (checkedKeys) => {
    const { quizState, setOptions } = this.props;
    const { options } = quizState;

    const nextOptions = update(options, { contentUuids: { $set: checkedKeys } });
    setOptions(nextOptions);
  };

  render() {
    const { quizState, productSlug } = this.props;
    const { allContentUuids, content, contentSkeleton, options } = quizState;
    const { contentUuids } = options;
    const itemsSelected = countItemsAvailable({ contentUuids, content });
    const isGre = productSlug === 'gre';

    return (
      <div className={styles.layout}>
        <div className={styles.layoutInner}>
          <div className={styles.instructions}>
            <div>
              <b>Limit review session to only these topics:</b>
            </div>
            <div>
              <i>25 (20) means 25 available, 20 ready</i>
            </div>
          </div>
          <ContentTree
            contentSkeleton={contentSkeleton}
            contentUuids={contentUuids}
            handleCheckboxesChange={this.handleCheckboxesChange}
          />
          <Checkbox
            indeterminate={
              contentUuids.length && contentUuids.length < allContentUuids.length
            }
            onChange={this.handleCheckAllChange}
            checked={allContentUuids.length === contentUuids.length}
          >
            Select all
          </Checkbox>
          {isGre && (
            <GreCheckboxes
              contentUuids={contentUuids}
              handleCheckAllQuantChange={this.handleCheckAllQuantChange}
              handleCheckAllVocabChange={this.handleCheckAllVocabChange}
            />
          )}
          <div className={styles.selectedItemPool}>
            Selected quiz pool: {itemsSelected}
          </div>
        </div>
      </div>
    );
  }
}

export default SessionOptions;
